// src/app/auth/callback/callback.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { filter, mergeMap } from 'rxjs';
import { UserService } from 'app/core/user/user.service';

@Component({
  selector: 'app-callback',
  template: `
      <p>Caricamento in corso...</p>
  `,
})
export class CallbackComponent implements OnInit {

  userData: any;

  constructor(
    private route: ActivatedRoute,
    private _authService: AuthService,
    private userService: UserService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this.route.queryParams.pipe(
      filter(params => !!params['state']), // Controlla che 'state' sia presente e non null o undefined
      mergeMap(params => {
        const state = params['state'];
        return this._authService.tokenRequest(state); // Effettua la chiamata solo se 'state' esiste
      })
    ).subscribe({
      next: (userData) => {
        this.userService.userData = userData;
        this._router.navigate(['/fornitori']);
      },
      error: (err) => {
        // Gestisci l'errore
        console.error('Token request error:', err);
        this._router.navigate(['/sign-in']);
      }
    });
  }


}
